import Modal from "../Modals/VanillaModal/VanillaModal";
import ErrorStackParser from "error-stack-parser";
import {
    getErrorDetailFromResponse,
    getErrorFromResponse,
    getExceptionClassFromResponse,
    getResultFromResponse,
    getStackTraceFromResponse,
    SUCCESS_STATUS
} from "./BaseDataFns";

const parseGarbage = ( toParse ) =>
{
    const regex = new RegExp('(\{.*\})(.*)', 'igm');

    const results = [...toParse.matchAll ( regex )] ;

    if ( results.length > 0 )
    {
        const attempt = results[0][1];

        let p = [] ;

        try {
            p = JSON.parse ( attempt )  ;

            console.log ( p )  ;

            return p ;
        }
        catch ( err )
        {
            console.log ( err ) ;

            return null ;
        }
    }
    else
    {
        return null ;
    }
}

function getThisErrorObject()
{
    try
    {
        throw Error("");
    }
    catch (err)
    {
        const res = ErrorStackParser.parse(err);

        return res;
    }
}

export const handleAjaxError = (jqXHR, exception, error, returnUrl) =>
{
    let msg = '';
    let fullMessage = '';

    console.error(jqXHR);

    if (jqXHR.constructor === TypeError || jqXHR.constructor === ReferenceError || jqXHR.constructor === Error)
    {
        msg = "Error";
        fullMessage = jqXHR.message + '<br><br>' + jqXHR.fileName + "<br><br>" + jqXHR.lineNumber + "<br><br>" + jqXHR.stack;
    }
    else
    {
        if (jqXHR.status === 0 || jqXHR.readyState === 0)
        {
            return;
        }

        if (exception === 'parsererror')
        {
            msg = error.message;
            msg += '<br><br>';
            msg += jqXHR.responseText;
        }
        else if (jqXHR.status === 0)
        {
            msg = 'Not connect.\n Verify Network.';
        }
        else if (jqXHR.status === 400)
        {
            msg = 'Bad Parameters. [400]' + '</p>';

            if (jqXHR.responseJSON != null)
            {
                const status = jqXHR.responseJSON;

                if (status.error === "Exception")
                {
                    fullMessage = "<p>Error File: " + status.errorDetail.file + '</p>';
                    fullMessage += "<p>Error Line: " + status.errorDetail.line + '</p>';
                    fullMessage += '<p>' + status.errorDetail.message + '</p>';
                }
            }
        }
        else if (jqXHR.status === 404)
        {
            if (jqXHR.responseJSON != null)
            {
                const status = jqXHR.responseJSON.status;

                if (status.error === "Exception")
                {
                    msg = 'API Not Found. [404]' ;

                    fullMessage = "<p>Error URL: " + status.errorDetail.file + '</p>';
                    fullMessage += '<p>' + status.errorDetail.message + '</p>';
                }
            }
            else
            {
                msg = 'Page Not Found. [404]' + '</p>';
            }
        }
        else if (jqXHR.status === 401)
        {
            msg = 'Not Authorised. [404]';
        }
        else if (jqXHR.status === 500)
        {
            msg = 'Internal Server Error [500].';

            if (jqXHR.responseJSON != null)
            {
                const status = jqXHR.responseJSON;

                if (status.error === "Exception")
                {
                    fullMessage = "<p>Error File: " + status.errorDetail.file + '</p>';
                    fullMessage += "<p>Error Line: " + status.errorDetail.line + '</p>';
                    fullMessage += '<p>' + status.errorDetail.message + '</p>';
                }
            }
            else if (jqXHR.responseText != null)
            {
                fullMessage = "<p>Error File: " + jqXHR.responseText + "</p>";
            }
        }
        else if (exception === 'parsererror')
        {
            msg = 'Requested JSON parse failed.';
        }
        else if (exception === 'timeout')
        {
            msg = 'Time out error.';
        }
        else if (exception === 'abort')
        {
            msg = 'Ajax request aborted.';
        }
        else
        {
            if (jqXHR.message != null)
            {
                msg = jqXHR.message;

                fullMessage = "<p>Error Stack: " + jqXHR.stack + "</p>";
            }
            else
            {
                // We have an unparseable error here so try to parse it using regex

                const statusResponse = parseGarbage( jqXHR.responseText );

                if ( statusResponse !== null )
                {
                    msg = "API Error" ;

                    fullMessage = translateErrorToHtml( statusResponse ) ;

                    fullMessage += "<div style='color: red;'>Further PHP warnings were generated. See console for details.</div>"
                }
                else
                {
                    msg = "Uncaught Error. " + jqXHR.responseText;
                }
            }
        }

        const stackFrames = getThisErrorObject();

        const callingFrame = stackFrames[2];

        if (fullMessage === '')
        {
            fullMessage = "Error occurred in function " + callingFrame.functionName + " in module " + callingFrame.fileName + " at line " + callingFrame.lineNumber;
        }

        if (jqXHR.status === 401)
        {
            fullMessage = "You are not authorised to perform this operation."
        }
    }

    const myModal = new Modal({
        title: msg,
        width: '500px',
        content: fullMessage
    }).show();
}

const extractErrorMessage = ( type, detail, stackTrace, startingOffset, skipArray ) =>
{
    let off = startingOffset ;
    let callingFunctionDetails ;
    let prevFunctionDetails ;
    let errorClass ;

    let exit = false ;

    while ( exit !== true )
    {
        callingFunctionDetails = stackTrace[off];
        errorClass = callingFunctionDetails.class ;

        if  ( skipArray.some ((elem) =>  { return errorClass.includes ( elem ) }))
        {
            off++ ;
        }
        else
        {
            prevFunctionDetails = stackTrace[off-1] ;
            exit = true ;
        }
    }

    let originalErrorFilename = detail.file;
    let originalFunctionLine = detail.line;
    const message = detail.message ;

    let originalFunctionName = stackTrace[0].function;

    let callingFunctionName = callingFunctionDetails.function ;

    originalFunctionLine = prevFunctionDetails.line;

    let displayMessage = "<p>Error File: " + originalErrorFilename + '</p>';
    displayMessage += "<p>Failed in function " + originalFunctionName + '() at line ' + originalFunctionLine + '</p>';
    displayMessage += '<p><b>' + message + '</b></p>';
    displayMessage += 'Called from <b>' + errorClass + '::' + callingFunctionName + ' Line ' + originalFunctionLine + '</b>' ;

    return displayMessage ;
}

const translateErrorToHtml = ( data ) =>
{
    let displayMessage = '';

    const type = getExceptionClassFromResponse(data) ;

    if ( type !== null )
    {
        // This is a new type of error with exception type so we can make some more specific decisions

        const detail = getErrorDetailromResponse(data) ;
        const stackTrace = getStackTraceFromResponse(data);

        if ( type.includes ( '\\APIAuthorisationException'))
        {
            // We need to inspect the stack to see where the error actually occurred

            let callingFunctionDetails = stackTrace[0];

            let callingFilename = callingFunctionDetails.file ;
            let callingFunctionName = callingFunctionDetails.function ;
            let callingFunctionLine = callingFunctionDetails.line ;

            if ( callingFunctionDetails.function === 'checkRights' )
            {
                // If we were called from checkRights, the actual culprit is the next level down
                callingFunctionDetails = stackTrace[1] ;
                callingFunctionName = callingFunctionDetails.function ;
            }

            displayMessage = "<p>Error File: " + callingFilename + '</p>';
            displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
            displayMessage += '<p><b>Authorisation Failed</b></p>';
        }
        else if (type.includes('\\APIEncryptedValueException'))
        {
            displayMessage = extractErrorMessage ( type, detail, stackTrace, 0, ['Encryptor', 'AjaxEndpoint', 'PDODatabase']) ;
        }
        else if ( type.includes ( '\\APIParameterException'))
        {
            // We need to inspect the stack to see where the error actually occurred

            let detail = getErrorDetailromResponse(data) ;

            const callingFunctionDetails = stackTrace[0];

            let callingFilename = detail.file ;
            let callingFunctionName = callingFunctionDetails.function ;
            let callingFunctionLine = detail.line ;

            displayMessage = "<p>Error File: " + callingFilename + '</p>';
            displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
            displayMessage += '<p><b>' + detail.message + '</b></p>';
        }
        else if ( type === 'Exception' )
        {
            // We need to inspect the stack to see where the error actually occurred

            let detail = getErrorDetailromResponse(data) ;

            const callingFunctionDetails = stackTrace[0];

            let callingFilename = detail.file ;
            let callingFunctionName = callingFunctionDetails.function ;
            let callingFunctionLine = detail.line ;

            displayMessage = "<p>Error File: " + callingFilename + '</p>';
            displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
            displayMessage += '<p><b>' + detail.message + '</b></p>';
        }
        else if ( type.includes ( 'PDOException'))
        {
            displayMessage = extractErrorMessage ( type, detail, stackTrace, 0, ['PDOStatement', 'PDODatabase', 'PDO']) ;
        }
        else if ( type === 'Error' || type === 'RuntimeException' || type === 'ParseError' || type.includes ( '\\Exception'))
        {
            // We need to inspect the stack to see where the error actually occurred

            let detail = getErrorDetailromResponse(data) ;

            let callingFunctionDetails = stackTrace[0];

            let callingFilename = detail.file ;
            let callingFunctionName = callingFunctionDetails.function ;
            let callingFunctionLine = detail.line ;

            displayMessage = "<p>Error File: " + callingFilename + '</p>';
            displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
            displayMessage += '<p><b>' + detail.message + '</b></p>';
        }
    }
    else if (getErrorFromResponse(data) === "PDO Exception")
    {
        const details = getErrorDetailFromResponse(data);

        displayMessage = "<p>Error File: " + details.file + '</p>';
        displayMessage += "<p>Error Line: " + details.line + '</p>';
        displayMessage += '<p>' + details.message + '</p>';
    }
    else if (getErrorFromResponse(data) === "Exception")
    {
        const details = getErrorDetailFromResponse(data);

        displayMessage = "<p>Error File: " + details.file + '</p>';
        displayMessage += "<p>Error Line: " + details.line + '</p>';
        displayMessage += '<p>' + details.message + '</p>';
    }
    else if (getErrorFromResponse(data) === "Application Error")
    {
        const details = getErrorDetailFromResponse(data);

        displayMessage += '<p style="text-align: center;">' + details.message + '</p>';
    }
    else if (getErrorFromResponse(data) === "Invaild JWT Token")
    {
        const emailContact = '<a href="mailto:info@school360.co.uk">info@school360.co.uk</a>'
        displayMessage = "<p>Invaild Token: Your security token has expired. Please contact the person who invited you to ARCBOX. Or email  " + emailContact + '</p>';
    }
    else if (getErrorFromResponse(data) === "REST")
    {
        const details = getErrorDetailFromResponse(data);

        displayMessage = "<p>A School360 application error occurred:</p>" +
            "<p><strong>" + details.message + "</p></strong>";
    }
    else if (getErrorFromResponse(data) === "PostmarkException")
    {
        const pmDetails = getErrorDetailFromResponse(data);

        const offendingFunction = pmDetails.trace[3] ;

        displayMessage = "<p>A Postmark Email Exception has occurred:<br/>" +
            "<strong>" + pmDetails.message + "</strong></p>";

        displayMessage += "<p>Error File: " + offendingFunction.file ;
        displayMessage += "<br/>Function: " + offendingFunction.function + '</p>';
    }
    else
    {
        displayMessage = "<p>Error: " + data.error + "</p>";
        displayMessage += "<p>Detail: " + data.errorDetail + "</p>";
    }

    return displayMessage ;
}

export const checkError = (data) =>
{
    if (data != null && data !== '')
    {
        if (getResultFromResponse(data) === SUCCESS_STATUS)
        {
            return true;
        }
        else
        {
            console.error(data);

            let displayMessage = translateErrorToHtml( data ) ;

            const myModal = new Modal({
                title: 'The operation failed',
                width: '500px',
                content: displayMessage
            }).show();
        }
    }
    else
    {
        const myModal = new Modal({
            title: 'The operation failed',
            width: '500px',
            content: 'Null Response From Server'
        }).show();
    }

    return false;
}
